import { render, staticRenderFns } from "./ClientInbox.vue?vue&type=template&id=b8109e98&scoped=true&lang=pug&"
import script from "./ClientInbox.vue?vue&type=script&lang=js&"
export * from "./ClientInbox.vue?vue&type=script&lang=js&"
import style0 from "./ClientInbox.vue?vue&type=style&index=0&id=b8109e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8109e98",
  null
  
)

export default component.exports